import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../AuthProvider";
import { useEffect } from "react";
import { Roles } from "../types/user.types";

export const useAuthGuard = (requiredRole: Roles) => {
  const navigate = useNavigate();
  const { authenticatedUser } = useAuthContext();

  useEffect(() => {
    // Check localStorage directly as a fallback - React state may not have synced yet
    const token = localStorage.getItem("accessToken");

    if (!authenticatedUser && !token) {
      navigate("/login");
      return;
    }

    // Only check role if we have authenticatedUser (state has synced)
    if (authenticatedUser && authenticatedUser.roleId !== requiredRole) {
      navigate("/login");
    }
  }, [authenticatedUser, navigate, requiredRole]);
};
